import { reactive } from '@vue/composition-api';
import { mesazhiIGabimit } from '@/utils/error-message';

export const getError = (error) => {
  // Nje fjali qe shpjegon vertet se cfare ndodhi. Me pare ktheheshin
  // objekte validimi ose teksti i pakuptueshem 'API Error, please try again',
  // dhe nje 'w' i mbetur ketu e rrezonte vete funksionin pikerisht kur
  // gabimi nuk kishte fushen 'errors' — p.sh. te nje 500.
  if (error && error.name === 'Fetch User') {
    return error.message;
  }

  return mesazhiIGabimit(error);
};

export const adminProfileStore = reactive({
  id: '',
  name: '',
  avatar: '',
  organisation_name: '',
});

export const activationStore = reactive({
  isActivated: true,
});
